var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('NaverMap',{attrs:{"zoom-level":_vm.zoomLevel,"tile-size-scale":_vm.tileSizeScale,"prop-options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }